import { MockedProvider } from '@apollo/client/testing';
import React from 'react';
import { WildcardMockLink } from '.';
/**
 * Render a test with an apollo provider and the provided mocks.
 */
export function withApolloMocks(testComponentFactory, apolloMocks, options) {
    if (apolloMocks === void 0) { apolloMocks = []; }
    if (options === void 0) { options = { addTypename: true }; }
    var link = new WildcardMockLink(apolloMocks, options);
    var element = (React.createElement(MockedProvider, { addTypename: options.addTypename, link: link, cache: options.cache }, testComponentFactory()));
    return { element: element, link: link };
}
/**
 * Make a wrapper (which can be passed to renderHook's `wrapper`) that provided
 * an apollo mocked provider using a WildcardMockLink. Returns the wrapper and
 * the link. See `clockHooks.spec.ts` for a good example of how to use it.
 */
export function hookWrapperWithApolloMocks(apolloMocks, options) {
    if (options === void 0) { options = { addTypename: true }; }
    var Wrap = options.Wrap;
    var link = new WildcardMockLink(apolloMocks, options);
    var wrapper = function (_a) {
        var children = _a.children;
        return (React.createElement(MockedProvider, { addTypename: options.addTypename, link: link }, Wrap ? React.createElement(Wrap, null, children) : children));
    };
    return { wrapper: wrapper, link: link };
}
//# sourceMappingURL=utils.js.map